// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "NewbuildingPromoModalContainer" + "." + "6eb29a3b0778ee2f6cc6" + ".css";
};